import React from 'react';

function PreviewBar({ children }) {
  // eslint-disable-next-line react/react-in-jsx-scope
  return <div className="preview-bar">{children}</div>;
}
export default PreviewBar;
